import { render, staticRenderFns } from "./ProductJsonld.vue?vue&type=template&id=c46cbb7e&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductJsonld.vue"
export default component.exports